import React, { useEffect, useState } from 'react';
import 'reactflow/dist/style.css';

function FlowPreview() {
  const [flow, setFlow] = useState({ nodes: [], edges: [] });
  const [stepIndex, setStepIndex] = useState(0);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    const stored = localStorage.getItem('previewFlow');
    if (stored) {
      const { nodes, edges } = JSON.parse(stored);
      const orderedNodes = nodes.sort((a, b) => a.position.y - b.position.y);
      setFlow({ nodes: orderedNodes, edges });
    }
  }, []);

  const currentNode = flow.nodes[stepIndex];
  const isLastStep = stepIndex === flow.nodes.length;

  const handleInputChange = (label, value) => {
    setFormData((prev) => ({ ...prev, [label]: value }));
  };

  const renderNodeContent = (node) => {
    const label = node.data?.label || 'Paso';
    const tipo = node.data?.type || 'texto';

    if (tipo === 'informativo') {
      const config = JSON.parse(node.data?.configJson || '{}');
      return <p>{config.text || 'Información'}</p>;
    }

    if (tipo === 'validacion') {
      return (
        <div className="field">
          <label className="label">{label}</label>
          <div className="control">
            <input
              className="input"
              type="file"
              onChange={(e) => handleInputChange(label, e.target.value)}
            />
          </div>
        </div>
      );
    }

    if (tipo === 'documento') {
      const config = JSON.parse(node.data?.configJson || '{}');
      return (
        <>
          {config.fields?.map((field, idx) => (
            <div className="field" key={idx}>
              <label className="label">{field.label}</label>
              <input
                type={field.type === 'select' ? 'text' : field.type}
                className="input"
                onChange={(e) => handleInputChange(field.label, e.target.value)}
              />
            </div>
          ))}
        </>
      );
    }

    if (tipo === 'formulario') {
      const config = JSON.parse(node.data?.configJson || '{}');
      return (
        <>
          {config.fields?.map((field, idx) => (
            <div className="field" key={idx}>
              <label className="label">{field.label}</label>
              {field.type === 'select' ? (
                <div className="select is-fullwidth">
                  <select
                    onChange={(e) => handleInputChange(field.label, e.target.value)}
                    value={formData[field.label] || ''}
                  >
                    <option value="">Seleccionar...</option>
                    {field.options?.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                </div>
              ) : (
                <input
                  type={field.type}
                  className="input"
                  value={formData[field.label] || ''}
                  onChange={(e) => handleInputChange(field.label, e.target.value)}
                />
              )}
            </div>
          ))}
        </>
      );
    }

    return <p>{label}</p>;
  };

  const renderSummary = () => (
    <div className="box">
      <h2 className="title is-4 mb-4">Resumen del Proceso</h2>
      <ul>
        {Object.entries(formData).map(([key, value]) => (
          <li key={key} className="mb-2">
            <strong>{key}:</strong>{' '}
            {typeof value === 'boolean' ? (value ? 'Sí' : 'No') : value}
          </li>
        ))}
      </ul>
      <div className="is-flex is-justify-content-center mt-4">
        <button
          className="button is-success"
          onClick={() => alert('✅ Contratación confirmada')}
        >
          Confirmar Contratación
        </button>
      </div>
    </div>
  );

  return (
    <div
      className="has-background-dark is-flex is-align-items-center is-justify-content-center"
      style={{ minHeight: '100vh', padding: '2rem' }}
    >
      <div className="container" style={{ maxWidth: '600px', width: '100%' }}>
        <div className="has-text-centered mb-6">
          <img
            src="https://kukenfi.kukenandev.es/logo/logo_oscuro.svg"
            alt="Kukenfi"
            style={{ maxWidth: '220px', marginBottom: '1rem' }}
          />
          <h1 className="title is-3 mt-3 has-text-white">Proceso de Contratación</h1>
        </div>

        <div className="card p-5">
          {isLastStep ? (
            renderSummary()
          ) : currentNode ? (
            <>
              <div className="mb-4">{renderNodeContent(currentNode)}</div>
              <div className="is-flex is-justify-content-space-between mt-4">
                <button
                  className="button"
                  disabled={stepIndex === 0}
                  onClick={() => setStepIndex((i) => i - 1)}
                >
                  Atrás
                </button>
                <button
                  className="button is-primary"
                  onClick={() => setStepIndex((i) => i + 1)}
                >
                  Siguiente
                </button>
              </div>
            </>
          ) : (
            <div className="notification is-warning has-text-centered">
              No se encontraron pasos para mostrar.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default FlowPreview;
